import { useLocation } from 'react-router-dom';

export const ucFirst = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const range = (numrows: number | undefined): number[] => {
  if (!numrows) return [];
  var rows = [];
  for (let i = 0; i < numrows; i++) {
    rows.push(i + 1);
  }
  return rows;
};

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const formatDate = (d: string | undefined) => {
  if (!d) return '';
  return new Date(d).toLocaleString();
};
